import {equals, flow, makeGet} from '@logistics-frontend/utils'

import {Action, ActionOpenRover, ActionWebTips, SharedRouteInfoResponse, WebPayNowAction} from 'src/api/types'
import {config} from 'src/shared/config'

type ActionsPayload = {
  headActions: Action[]
  footActions: Action[]
  paymentAction?: WebPayNowAction
  webTipsAction?: ActionWebTips
  isShowFeedback: boolean
  openRoverActions: ActionOpenRover[]
}

const headActionTypes = ['open_universal_link', 'performer_call', 'deeplink']
const footActionTypes = ['cancel_v2', 'show_support_web', 'open_yandex_messenger_support_chat']

function isWebPayNowAction(action: Action): action is WebPayNowAction {
  return action.type === 'pay_now_in_web'
}

function isWebTipsAction(action: Action): action is ActionWebTips {
  return action.type === 'web_tips'
}

function isRoverAction(action: Action): action is ActionOpenRover {
  return action.type === 'rover'
}

export function toActionsPayload(info: SharedRouteInfoResponse): ActionsPayload {
  const {actions = []} = info
  const initialActions: ActionsPayload = {
    headActions: [],
    footActions: [],
    isShowFeedback: false,
    openRoverActions: [],
  }

  if (info.performer) {
    initialActions.headActions.push({
      type: 'performer_badge',
      performer: info.performer,
    })
  }

  return actions.reduce<ActionsPayload>(function (acc: ActionsPayload, action: Action): ActionsPayload {
    if (headActionTypes.includes(action.type)) {
      acc.headActions.push(action)
    }
    if (isWebPayNowAction(action)) {
      acc.paymentAction = action
    }
    if (isWebTipsAction(action)) {
      acc.webTipsAction = action
    }
    if (footActionTypes.includes(action.type)) {
      acc.footActions.push(action)
    }
    if (action.type === 'feedback') {
      acc.isShowFeedback = true
    }
    if (isRoverAction(action)) {
      acc.openRoverActions.push(action)
    }

    return acc
  }, initialActions)
}

export function isCountry(countryIsoCode: string) {
  const {country} = config

  return countryIsoCode === country
}

const infoGet = makeGet<SharedRouteInfoResponse>()

export const isBannerPositionUp: (routeInfo: SharedRouteInfoResponse) => boolean = flow(
  infoGet('promo_banner.banner_position'),
  equals('up'),
)
